
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button }from '@cmsgov/design-system';



const TagsManagerHeader = props => {

    const {
        openTagModal,
        tagsQty
    } = props;

    const createTag = () => {
        openTagModal();
    };

    return (
        <div className = 'margin-bottom-2em'>
            <span className='pull-left'>
                <FormattedMessage
                    id = 'ticket_management.tags_total'
                    values = {{ tagsQty }}
                />
            </span>
            <span className='pull-right'>
                <Button
                    className = 'usa-button gi-button gi-button__primary'
                    onClick = { createTag }
                >
                    <FormattedMessage id = 'button.crete_new_tag'/>
                </Button>
            </span>
        </div>
    );
};

export default TagsManagerHeader;